module.exports = __webpack_public_path__ + "img/empty-products.16d47350.svg";